module.exports = __webpack_public_path__ + "img/tit-resources.dc6ae5a0.png";